// Leasing-related API helpers (Iter B + Public Listing Generator)
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const leasingApi = {
  // Listings
  listListings:   (status) => axios.get(`${API}/listings${status ? `?status=${status}` : ''}`, { headers: auth() }),
  createListing:  (body) => axios.post(`${API}/listings`, body, { headers: auth() }),
  publishListing: (lid)  => axios.post(`${API}/listings/${lid}/publish`, {}, { headers: auth() }),
  deleteListing:  (lid)  => axios.delete(`${API}/listings/${lid}`, { headers: auth() }),

  // Prospects
  listProspects:    (stage) => axios.get(`${API}/prospects${stage ? `?stage=${stage}` : ''}`, { headers: auth() }),
  createProspect:   (body) => axios.post(`${API}/prospects`, body, { headers: auth() }),
  transitionProspect: (pid, body) => axios.post(`${API}/prospects/${pid}/transition`, body, { headers: auth() }),

  // Applicants
  listApplicants:   () => axios.get(`${API}/applicants`, { headers: auth() }),
  createApplicant:  (body) => axios.post(`${API}/applicants`, body, { headers: auth() }),
  screenApplicant:  (aid) => axios.post(`${API}/applicants/${aid}/screen`, {}, { headers: auth() }),
  decideApplicant:  (aid, body) => axios.post(`${API}/applicants/${aid}/decision`, body, { headers: auth() }),

  // Pipeline
  pipeline: () => axios.get(`${API}/leasing/pipeline`, { headers: auth() }),

  // Public (no auth)
  publicListing:  (slug) => axios.get(`${API}/public/listing/${slug}`),
  publicLead:     (slug, body) => axios.post(`${API}/public/listing/${slug}/lead`, body),
};

export const workOrderApi = {
  get:          (wid) => axios.get(`${API}/work-orders/${wid}`, { headers: auth() }),
  transition:   (wid, body) => axios.post(`${API}/work-orders/${wid}/transition`, body, { headers: auth() }),
  comment:      (wid, body) => axios.post(`${API}/work-orders/${wid}/comment`, body, { headers: auth() }),
  assign:       (wid, body) => axios.post(`${API}/work-orders/${wid}/assign`, body, { headers: auth() }),
  addCost:      (wid, body) => axios.post(`${API}/work-orders/${wid}/cost`, body, { headers: auth() }),
  timeline:     (wid) => axios.get(`${API}/work-orders/${wid}/timeline`, { headers: auth() }),
  aiRecommend:  (wid) => axios.get(`${API}/work-orders/${wid}/ai-recommend`, { headers: auth() }),
};
